// extracted by mini-css-extract-plugin
export var buttonContent = "_40-0";
export var centered = "_40-1";
export var centeredFlex = "_40-2";
export var errorText = "_40-3";
export var icon = "_40-4";
export var iconButtonContent = "_40-5";
export var monospace = "_40-6";
export var padded = "_40-7";